export const getPostInstallationUrlWithQuery = ({
  appId,
  tenantId,
  instanceId,
  postInstallationUrl,
}: {
  appId: string;
  tenantId: string;
  instanceId: string | undefined;
  postInstallationUrl: string;
}): string | undefined => {
  try {
    const url = new URL(postInstallationUrl);
    url.searchParams.set('appId', appId);
    url.searchParams.set('tenantId', tenantId);
    url.searchParams.set('instanceId', instanceId || '');

    return url.toString();
  } catch (e) {
    return;
  }
};
